import { baseFeatures } from 'reactApp/constants/products/baseFeatures';
import { quotaFeatures } from 'reactApp/constants/products/quotaFeatures';
import { quotaProFeatures } from 'reactApp/constants/products/quotaPro';

export const features = {
    ...baseFeatures,
    ...quotaFeatures,
    ...quotaProFeatures,
};
